<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>Medallón conmemorativo</h2>
    <img @click="imageClicked(0)" src="galerias/independencia/g6_1/G6_1.png" class="mainphoto"/>
    <p class="photo-description">Glorias de 1810. Medallón conmemorativo. Autor Anastacio Vargas, miniatura al óleo. Col Museo Histórico ex Curato de Dolores.</p>
    <p>Consulta los detalles de esta pieza en este link.<ul><li><a target="_blank" href="http://mediateca.inah.gob.mx/islandora_74/islandora/object/pintura%3A4297">mediateca.inah.gob.mx</a></li></ul></p> 
  </div>
</template>

<script>
export default {
  name: "Sala3m7",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
